// @ts-nocheck
import React from 'react'
import styled from 'styled-components'
import {LoadingLayer} from "../LoadingLayer";

type Block3Types = {
    className?: string,
    mainText?: string,
    loading?: any,
    subText?: string,
    icon?: any,
    bg: 'pink' | 'blue' | 'lightBlue'
}

function Block3(props: Block3Types) {

    const palette = {
        pink: '#FF007C',
        blue: '#0659C1',
        lightBlue: '#009FF5'
    }


    return (
        <StyledBlock3 bg={palette[props.bg]} className={props.className}>
            <div className='icon'> {props.icon} </div>
            <div className='mainText'><b>{props.mainText}</b></div>
            <div className='subText'>  {props.subText}</div>
            {props.loading && <LoadingLayer/>}

        </StyledBlock3>
    )
}


Block3.defaultProps = {
    key: 'Key',
    mainText: 'mainText',
    subText: 'subText',
    bg: 'pink'

}


export default Block3

const StyledBlock3 = styled.div`
  filter: drop-shadow(0px 3px 6px rgba(39, 45, 59, 0.2));
  display: flex;
  width: 100%;
  max-width: 200px;
  height: 200px;
  border-radius: 15px;
  align-items: flex-start;
  box-sizing: border-box;
  background-color: ${(p: string) => p.bg};
  color: white;
  flex-direction: column;
  padding: 0 16px;
  font-family: "Open Sans";

  .mainText {
    font-size: 28px;
    margin-top: 65px;
    font-family: "Montserrat", "Open Sans";
    b {
      color: white;
    }

  }

  .subText {
    font-size: 16px;
    color: white;
  }


`
